// Written by the admin field-summary endpoint next to the run's profile.json; the button downloads the CSV
export const FIELD_SUMMARY_CSV = "field_summary.csv";

// Only a profile run that finished with a profile.json, worker-made or uploaded, can be summarised.
// `status` must be the run's status response: the runs list has no step, and a stopped run carries DONE too.
export const canMakeFieldSummary = (runType, status) =>
  runType !== "gen" && status?.step === "done" && !!status?.has_profile;
